// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ywu9","row":"ProcedureTreatmentSummary_row__2HboY"};